// extracted by mini-css-extract-plugin
module.exports = {"product_compare_card":"compare_product_compare_card__o_OaV"};